import React, { useState, useEffect, useRef } from 'react';
import './userProfileSidebar.scss'
import { AccountIcon, LocationIcon, LogoutIcon, ManageIcon, NotificationIcon, PasswordIcon, RefferIcon, DownArrow, EmailIcon, CalendarIcon } from '../../../components/Icons'
import LogOut from "../../../modals/logout/LogOut";
import Suggestion from '../../../modals/suggestion/Suggestion';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../slice/authSlice';
const UserProfileSidebar = ({ scrollToSection }) => {
  const [activeTab, setActiveTab] = useState('Account setting');
  const [logoutModel, setLogoutModel] = useState(false);
  const [suggestionModal, setsuggestionModal] = useState(false);

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const location = useLocation();
  const section = location.state && location.state.section;
  const user = useSelector(selectUser);

  const listRef = useRef(null);


  const handleTabClick = (index) => {
    setActiveTab(index);


    if (dropdownOpen) {
      setDropdownOpen(false);
    }


    scrollToSection(index.toLowerCase().replace(' ', '-'));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (listRef.current && !listRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  useEffect(() => {
    const index =   stringCompare()
    scrollToSection(section)
    setActiveTab(index);
  }, [section]);

  const stringCompare =  () =>{
    if(section === "account-setting") return "Account setting"
    if (section === "manage-address") return 'Manage Address'
    if  (section === "manage-payment") return 'Manage Payment'
    if  (section === "refer-friend") return 'Refer friend'
    if  (section === "marketing-email") return 'Marketing Email'
    if  (section === "manage-schedule") return 'Manage Schedule'
  }

  return (
    <>
      <div className='user-profile-sidebar'>
        <div className='box-wrapper'>
          <ul className='sidebar-list'>
            <li className={`${activeTab === 'Account setting' ? 'active' : ''}`} onClick={() => handleTabClick('Account setting')}><i><AccountIcon /></i> Account setting</li>
            <li className={`${activeTab === 'Manage Address' ? 'active' : ''}`} onClick={() => handleTabClick('Manage Address')} ><i><LocationIcon /></i> Manage Address</li>
            {user?.marketingEmail !== null && <li className={`${activeTab === 'Marketing Email' ? 'active' : ''}`} onClick={() => handleTabClick('Marketing Email')} ><i><EmailIcon /></i> Marketing Email</li> }
            <li className={`${activeTab === 'Password' ? 'active' : ''}`} onClick={() => handleTabClick('Password')} ><i><PasswordIcon /></i> Password</li>
            <li className={`${activeTab === 'Manage Payment' ? 'active' : ''}`} onClick={() => handleTabClick('Manage Payment')}><i><ManageIcon /></i> Manage your payment methods </li>
            <li className={`${activeTab === 'Manage Schedule' ? 'active' : ''}`} onClick={() => handleTabClick('Manage Schedule')}><i><CalendarIcon /></i> Manage your appointment schedule </li>
            <li className={`${activeTab === 'Refer friend' ? 'active' : ''}`} onClick={() => handleTabClick('Refer friend')}><i><RefferIcon /></i> Refer a friend</li>
            <li className={activeTab === 'Suggestion' ? 'active' : ''} onClick={() => { handleTabClick('Suggestion'); setsuggestionModal(true); }}>
  <i><LogoutIcon /></i> Suggestion
</li>
            <li className={`${activeTab === 'Notifications' ? 'active' : ''}`} onClick={() => handleTabClick('Notifications')}><i><NotificationIcon /></i> Notifications setting</li>
            {/* <li className={`${activeTab === 'Logout' ? 'active' : ''}`} onClick={() => {handleTabClick('Logout');setLogoutModel(true);}}><i><LogoutIcon /></i> Logout</li> */}
            <li className={activeTab === 'Logout' ? 'active' : ''} onClick={() => { handleTabClick('Logout'); setLogoutModel(true); }}>
  <i><LogoutIcon /></i> Logout
</li>

          </ul>

          <div className='sidebar-list-dropdown' onClick={toggleDropdown}>
            <div>{activeTab}</div> <div><DownArrow /></div>
            {dropdownOpen && (
              <ul ref={listRef}>

                <li className={`${activeTab === 'Account setting' ? 'active' : ''}`} onClick={() => handleTabClick('Account setting')}> Account setting</li>
                <li className={`${activeTab === 'Manage Address' ? 'active' : ''}`} onClick={() => handleTabClick('Manage Address')}> Manage Address</li>
                {user?.marketingEmail !== null && <li className={`${activeTab === 'Marketing Email' ? 'active' : ''}`} onClick={() => handleTabClick('Marketing Email')} ><i><EmailIcon /></i> Marketing Email</li>}
                <li className={`${activeTab === 'Password' ? 'active' : ''}`} onClick={() => handleTabClick('Password')} > Password</li>
                <li className={`${activeTab === 'Manage Payment' ? 'active' : ''}`} onClick={() => handleTabClick('Manage Payment')}>Manage your payment methods </li>
                <li className={`${activeTab === 'Manage Schedule' ? 'active' : ''}`} onClick={() => handleTabClick('Manage Schedule')}>Manage your appointment schedule </li>
                <li className={`${activeTab === 'Refer friend' ? 'active' : ''}`} onClick={() => handleTabClick('Refer friend')} >Refer a friend</li>
                <li className={`${activeTab === 'Suggestion' ? 'active' : ''}`} onClick={() => {handleTabClick('Suggestion'); setsuggestionModal(true); }}>Suggestion</li>

                <li className={`${activeTab === 'Notifications' ? 'active' : ''}`} onClick={() => handleTabClick('Notifications')}> Notifications setting</li>
                <li className={`${activeTab === 'Logout' ? 'active' : ''}`} onClick={() => {handleTabClick('Logout'); setLogoutModel(true); }}>Logout</li>

              </ul>
            )}
          </div>
        </div>
      </div>
      {logoutModel ? <LogOut logoutModel={logoutModel} setLogoutModel={setLogoutModel} /> : ""}
      {suggestionModal ? <Suggestion suggestionModal={suggestionModal} setsuggestionModal={setsuggestionModal} /> : ""}

    </>
  )
}

export default UserProfileSidebar
